import { createFileRoute } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { useNavigate } from "@tanstack/react-router";
import { Button, Link, Surface } from "@heroui/react";
import { ChevronRight, IdCard, MessageSquareLock } from "lucide-react";

export const Route = createFileRoute("/help/account_recovery/menu")({
  component: AccountRecoveryMenu,
});


export default function AccountRecoveryMenu() {
  const navigate = useNavigate();
  return (
    <div className={"min-h-screen flex flex-col bg-gray-100 px-4"}>
      <div className={"mt-8"}>
        <div className="text-2xl font-bold mb-1">
          忘记账号或丢失访问权限？
        </div>
        <div className={"text-md text-gray-500 mb-2 text-lg"}>让我们来帮助你</div>
      </div>

      <div className={"flex flex-col w-full max-w-md mt-6"}>
        <span className={"text-md text-gray-500 mb-2 text-sm"}>可通过下面任意方式找回您的账号</span>
        <Surface variant="default" className="flex flex-col rounded-xl overflow-hidden">
          <F2ASelectItem
            title="通过绑定的手机号找回"
            icon={<MessageSquareLock />}
            onPress={() => navigate({ to: "/help/account_recovery/phone" })}
          />
          <F2ASelectItem
            title="通过实名信息找回"
            icon={<IdCard />}
            onPress={() => navigate({ to: "/help/account_recovery/id" })}
          />
        </Surface>
      </div>
      <Link className="text-sm text-primary mt-4 no-underline" onPress={() => navigate({ to: "/help" })}>
        需要帮助吗？<span className="underline underline-offset-4 text-accent">点这里联系人工客服</span>
      </Link>
    </div>
  );
}

function F2ASelectItem({
  title,
  icon,
  onPress,
}: {
  title: string;
  icon: ReactNode;
  onPress: () => void;
}) {
  return (
    <Button
      variant="ghost"
      className="w-full justify-between rounded-none h-auto py-4 border-b last:border-b-0"
      onPress={onPress}
    >
      <span className={"text-sm shrink-0 flex items-center gap-2"}>
        {icon} {title}
      </span>
      <ChevronRight size={16} />
    </Button>
  );
}
